<template>
  <div class="page pi-charging">
    <div class="container-flex">
      <div class="pi-charging-info">
        <div class="charging-my-car">
          <router-link :to="'/car-list?type=select&orderNo=' + info.orderNo">
            <div class="license-plate">{{info.carNo || '暂无车牌'}} <span>切换</span>  </div>
          </router-link>
          <div class="my-car-img">
            <template v-for="(item,index) in cardIme">
              <div class="car-bg-item"
                  :key="index"
                  v-show="item.show">
                <img v-if="index == 0"
                    src="../../../assets/image/car-1.png"
                    alt="">
                <img v-if="index == 1"
                    src="../../../assets/image/car-2.png"
                    alt="">
                <img v-if="index == 2"
                    src="../../../assets/image/car-3.png"
                    alt="">
                <img v-if="index == 3"
                    src="../../../assets/image/car-4.png"
                    alt="">
                <img v-if="index == 4"
                    src="../../../assets/image/car-5.png"
                    alt="">
                <img v-if="index == 5"
                    src="../../../assets/image/car-6.png"
                    alt="">
              </div>
            </template>
            <div class="car-text"
                v-if="soc">{{soc}}<span class="unit">%</span></div>
            <img v-else
                src="../../../assets/image/charging.png"
                class="charging-icon"
                alt="">
            <div class="max-soc-box" @click="goSocTips" v-if="info.topSoc">
              车辆可充至 <img src="../../../assets/image/wen.png" alt="">
              <div class="soc-number">{{info.topSoc}}%</div>
            </div>
          </div>
          <p class="charging-time"
            v-if="soc">预计还需{{info.remainTime}}分钟充满</p>
        </div>
        <div class="charging-data">
          <div class="charging-data-flex">
            <div class="charging-value">{{info.chargeElect || '--'}}<span class="unit">kWh</span></div>
            <div class="charging-text">已充电量</div>
          </div>
          <div class="charging-data-flex">
            <div class="charging-value">{{info.chargeAmount && info.chargeAmount>=0 ? info.chargeAmount : '0'}}元</div>
            <div class="charging-text">充电金额</div>
          </div>
          <div class="charging-data-flex">
            <div class="charging-value" v-if="info.chargeMinutes == '0' || info.chargeMinutes == '0秒'">--</div>
            <div class="charging-value" v-else>{{info.chargeMinutes || '--'}}</div>
            <div class="charging-text">充电时长</div>
          </div>
          <div class="charging-data-flex">
            <div class="charging-value">{{info.voltage || '--'}}<span class="unit">V</span></div>
            <div class="charging-text">电压</div>
          </div>
          <div class="charging-data-flex">
            <div class="charging-value">{{info.current || '--'}}<span class="unit">A</span></div>
            <div class="charging-text">电流</div>
          </div>
          <div class="charging-data-flex">
            <div class="charging-value">{{getPower(info.power) || '--'}}<span class="unit">kW</span></div>
            <div class="charging-text">功率</div>
          </div>
        </div>
        <div class="white-circular"
            @click="openTel">
          <img src="../../../assets/image/customer-service.png"
              alt="">
        </div>
        <div class="white-circular details">
          <router-link :to="'/station-detail?staPkId='+ info.staPkId"
                      class="main-color">
            站点详情
          </router-link>
        </div>
        
      </div>
      <div class="sta-info">
        <div class="row-info" v-if="info.staName">
          <div class="row-name">充电站名称</div>
          <div class="row-value">{{info.staName}}</div>
        </div>
        <div class="row-info" v-if="info.pileName">
          <div class="row-name">充电桩名称</div>
          <div class="row-value">{{info.pileName}}</div>
        </div>
        <div class="row-info" v-if="info.gunName">
          <div class="row-name">充电枪编号</div>
          <div class="row-value">{{info.gunPkId}} - {{info.gunName}}枪</div>
        </div>
      </div>
    </div>
    <div class="botton-btn">
      <pi-button :type="doStopAction ? 'loading' : 'primary'"
                 block
                 @click="onStopChargeClick">
        {{doStopAction? '订单上传中' : '结束充电'}}
        <span v-if="doStopAction">{{leftTime.s}}{{leftTime.ms}}秒</span>
      </pi-button>
      <pi-button block
                 class="mgt"
                 @click="goHome">返回首页</pi-button>
    </div>

  </div>
</template>

<script>
import { Cell, CellGroup } from "vant";
import {
  startChargeRealtimeData,
  stopCharge,
  getUserBaseInfo,
  getStaPhone,
} from "../../../common/api";
import PiCircleProcess from "../../../components/pi-circle-process/pi-circle-process";

export default {
  name: "charging",
  components: {
    [PiCircleProcess.name]: PiCircleProcess,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
  },
  data() {
    return {
      process: null,
      doStopAction: false,
      charging: true,
      pauseEndTime: new Date(),
      info: {},
      leftTime: { s: null, ms: null },
      // accountPkId: null,
      // gunNumber: null,
      // serialNumber: null,
      orderNo: null,
      timer: null,
      timeout: null,
      gunNumberObj: {
        A: 1,
        B: 2,
        C: 3,
      },
      cardIme: [
        { show: false },
        { show: false },
        { show: false },
        { show: false },
        { show: false },
        { show: false },
      ],
      cardImeIndex: -1,
      cardTimer: null,
      soc: 0,
      userInfo: {},
      stationPhone: "",
      isGetPhone: false,
      isCountDown: false, // 倒计时还是顺时
      flagIndex: 0,
    };
  },
  props: {
    propOrderNo: {
      type: String,
      default: ''
    }
  },
  mounted() {
    // this.accountPkId = this.$route.query.accountPkId;
    // this.gunNumber = this.$route.query.gunNumber;
    // this.serialNumber = this.$route.query.serialNumber;

    this.orderNo = this.propOrderNo == '' ? this.$route.query.orderNo : this.propOrderNo;
    this.startChargeRealtimeData();
    this.pollUpdate();
    this.getUserInfo();
    this.cardImgShow();
  },

  methods: {
    getPower(val) {
      if (val > 0) {
        return (val / 1000).toFixed(2);
      } else {
        return "--";
      }
    },
    goSocTips(){
      this.$router.push("/charge/sco-tips?soc=" + this.info.topSoc);
    },
    goHome() {
      this.$router.push("/home");
    },
    getUserInfo() {
      getUserBaseInfo(null, true).then((response) => {
        if (
          response.status == this.$config.ajaxStatus &&
          response.data.length > 0
        ) {
          this.userInfo = response.data[0];
        }
      });
    },
    cardImgShow() {
      this.cardTimer = setTimeout(() => {
        // cardImeIndex 是第几个格子亮，车一共有6个格子，一个格子就是 16.66%
        if (this.cardImeIndex < this.cardIme.length - 1) {
          this.cardImeIndex = this.cardImeIndex + 1;
        } else {
          if (this.soc >= 0) {
            this.cardImeIndex = parseInt(this.soc / 16.66) - 1;
          } else {
            this.cardImeIndex = -1;
          }
        }
        this.cardIme.map((item, index) => {
          if (index <= this.cardImeIndex) {
            item.show = true;
          } else {
            item.show = false;
          }
        });
        this.cardImgShow();
      }, 700);
    },
    startChargeRealtimeData() {
      startChargeRealtimeData({
        orderNo: this.orderNo,
        // gunNumber: this.gunNumber
      },false)
        .then((data) => {
          // console.log(data);
          if (data.status === this.$config.ajaxStatus) {
            this.info = data.data[0];
            if (!this.$common.isEmpty(this.info.chargePercent)) {
              let process = this.info.chargePercent.replace("%", "");
              this.process = Number(process) / 100;
            }
            this.soc = this.info.soc || 0;
            if (data.data[0].orderStatus === 2) {
              //充电完成，跳转到充电结束界面等待拔枪
              this.$router.replace({
                name: "charge/finish",
                query: {
                  // accountPkId: this.accountPkId,
                  // gunNumber: this.gunNumber,
                  // serialNumber: this.serialNumber,
                  orderNo: this.orderNo,
                  replace: true
                },
              });
            } else if (data.data[0].orderStatus === 6) {
              // 自动结算
              this.$router.replace({
                name: "pay-success",
                query: {
                  orderNo: this.orderNo,
                  replace: true
                },
              });
            } else if (
              data.data[0].orderStatus === 5 ||
              data.data[0].orderStatus === 9
            ) {
              //充电完成，待支付，跳转到支付界面
              this.$router.replace({
                name: "order-not-pay",
                query: {
                  // accountPkId: this.accountPkId,
                  // gunNumber: this.gunNumber,
                  // serialNumber: this.serialNumber,
                  orderNo: this.orderNo,
                  replace: true
                },
              });
            }else if (data.data[0].handleFlag == 1 || data.data[0].handleFlag == 2 && this.flagIndex >= 3){
              this.$dialog.alert({
                title: '订单异常',
                confirmButtonText: '确认',
                confirmButtonColor: '#14CC80',
                closeOnPopstate: true
              }).then(() => {
                // router.replace({name: 'home2'});
                this.$router.go(-1);
              }).catch(() => {});
            } else {
              if (data.data[0].handleFlag == 2 && this.flagIndex <= 3){
                //再等待 15 秒,如果还没变就提示异常
                this.flagIndex = this.flagIndex + 1;
              }else{
                this.$common.checkOrderIsAbnormal(
                  this.$router,
                  data.data[0].orderStatus
                );
              }
            }
            if (!this.isGetPhone) {
              this.isGetPhone = true;
              this.getDetail();
            }
          } else {
            throw new Error(data.msg);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getDetail() {
      getStaPhone(
        {
          staPkId: this.info.staPkId,
        },
        true
      ).then((data) => {
        if (data.status === this.$config.ajaxStatus) {
          this.stationPhone = data.data[0];
          console.log(this.stationPhone);
        }
      });
    },
    openTel() {
      window.location.href = "tel:" + this.stationPhone;
    },
    pollUpdate() {
      this.timer = setInterval(() => {
        this.refresh();
      }, this.$config.pullTimeDistance);
    },
    refresh() {
      this.startChargeRealtimeData();
    },
    onStopChargeClick() {
      this.doStopAction = true;
      stopCharge({
        orderNo: this.orderNo,
      })
        .then((data) => {
          // console.log(data);
          if (data.status === this.$config.ajaxStatus) {
            this.pauseEndTime = new Date();
            var n = this.isCountDown ? 3 : 0;
            this.pauseEndTime = new Date();
            //倒计(this.isCountDown)或者顺时时3分钟
            this.pauseEndTime.setMinutes(
              this.pauseEndTime.getMinutes() + n,
              this.pauseEndTime.getSeconds(),
              0
            );
            this.countDown();
          } else {
            this.doStopAction = false;
            this.$toast(data.msg);
          }
        })
        .catch((error) => {
          this.doStopAction = false;
          console.log(error);
          this.$toast("请求失败");
        });
    },

    countDown() {
      var nowTime = new Date();
      var leftTime;
      var ms;
      if (this.isCountDown) {
        leftTime = parseInt(
          (this.pauseEndTime.getTime() - nowTime.getTime()) / 1000
        );
        ms = parseInt((this.pauseEndTime.getTime() - nowTime.getTime()) % 1000);
      } else {
        leftTime = parseInt(
          // 顺时
          (nowTime.getTime() - this.pauseEndTime.getTime()) / 1000
        );
        ms = parseInt((nowTime.getTime() - this.pauseEndTime.getTime()) % 1000);
      }
      var m = parseInt((leftTime / 60) % 60);
      var s = parseInt(leftTime % 60);

      this.leftTime.s = `${m * 60 + s}.`;
      this.leftTime.ms = `${parseInt(ms / 100)}`;
      // if (leftTime <= 0) {
      if (
        (this.isCountDown && leftTime <= 0) ||
        (!this.isCountDown && leftTime >= 180)
      ) {
        this.$dialog
          .alert({
            title: "订单上传失败",
            confirmButtonText: "确认",
            confirmButtonColor: "#14CC80",
            closeOnPopstate: true,
          })
          .then(() => {
            this.$router.go(-1);
          })
          .catch(() => {});
        return;
      }
      this.timeout = setTimeout(this.countDown, 100);
    },
    addZero(num) {
      return num < 10 ? "0" + num : num;
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
    clearTimeout(this.timeout);
    clearTimeout(this.cardTimer);
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/less/old/var.less";
.pi-charging {
  display: flex;
  min-height: 100%;
  flex-direction: column;
  .pi-charging-info {
    background-color: #333333;
    color: #fff;
    position: relative;
    .white-circular {
      box-shadow: 0px 0px 19px 0px rgba(0, 0, 0, 0.2);
      position: absolute;
      width: 1rem;
      height: 1rem;
      border-radius: 50%;
      right: 0;
      bottom: -0.5rem;
      align-items: center;
      justify-content: center;
      display: flex;
      color: @main-color;
      font-size: 0.26rem;
      line-height: 0.37rem;
      background-color: #fff;
      border-radius: 50%;
      cursor: pointer;
      img {
        width: 0.54rem;
        height: 0.54rem;
      }
    }
    .white-circular.details {
      bottom: -2.03rem;
      padding: 0 0.2rem;
      box-sizing: border-box;
      text-align: center;
    }
    .charging-my-car {
      height: 3.6rem;

      box-sizing: border-box;
      padding: 0.35rem 0;
      text-align: center;
      .license-plate {
        font-size: 0.36rem;
        line-height: 0.5rem;
        font-weight: 600;
        margin-bottom: 0.1rem;
        color: #fff;
        span{
          color: @main-color;
          margin-left: 0.2rem;
          font-size: 0.28rem;
        }
      }
      .my-car-img {
        width: 3.6rem;
        height: 1.78rem;
        padding: 0.1rem 0;
        box-sizing: border-box;
        margin: auto;
        position: relative;
        background-image: url("../../../assets/image/car.png");
        background-size: 100% 100%;
        font-size: 0;
        text-align: left;
        .car-bg-item {
          width: 16.66%;
          height: 100%;
          display: inline-block;
          vertical-align: top;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .car-bg-item:nth-child(1) {
          opacity: 0.6;
        }
        .car-bg-item:nth-child(2) {
          opacity: 0.5;
        }
        .car-bg-item:nth-child(3) {
          opacity: 0.4;
        }
        .car-bg-item:nth-child(4) {
          opacity: 0.3;
        }
        .car-bg-item:nth-child(5) {
          opacity: 0.2;
        }
        .car-bg-item:nth-child(6) {
          opacity: 0.1;
        }
        .charging-icon,
        .car-text {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
        .charging-icon {
          width: 1.18rem;
          height: 0.62rem;
        }
        .car-text {
          font-size: 0.72rem;
          line-height: 1rem;
          padding-right: 0.43rem;
          .unit {
            font-size: 0.26rem;
          }
        }
      }
      .charging-time {
        font-size: 0.26rem;
        line-height: 0.37rem;
        color: #bbbbbb;
        margin-top: 0.14rem;
      }
    }
    .charging-data {
      background: rgba(255, 255, 255, 0.05);
      border-radius: 0px 0px 10px 10px;
      display: flex;
      flex-wrap: wrap;
      text-align: center;
      padding-top: 0.3rem;
      .charging-data-flex {
        width: 33.33%;
        margin-bottom: 0.3rem;
        .charging-value {
          font-size: 0.38rem;
          line-height: 0.53rem;
          .unit {
            font-size: 0.26rem;
          }
        }
        .charging-text {
          color: #bbbbbb;
          font-size: 0.26rem;
          line-height: 0.37rem;
          margin-top: 0.1rem;
        }
      }
    }
  }
  .btn-flex {
    flex: 1;
    align-self: flex-end;
  }
  .botton-btn {
    padding: 0.35rem 0.4rem;
    .mgt {
      margin-top: 0.2rem;
    }
  }
  .max-soc-box{
    background-color: #fff;
    border-radius: 0.06rem;
    font-size: 0.2rem;
    line-height: 0.28rem;
    color: #333;
    position: absolute;
    right: -1.62rem;
    top: 50%;
    padding: 0.03rem 0.1rem;
    transform: translateY(-50%);
    img{
      width: 0.28rem;
      height: 0.28rem;
      vertical-align: text-top;
    }
    .soc-number{
      font-size: 0.26rem;
      line-height: 0.37rem;
      text-align: center;
    }
  }
  
  .sta-info{
    padding: 0.2rem 0.3rem;
  }
  .sta-info .row-info{
    margin-top: 0.1rem;
    display: flex;
    font-size: 0.28rem;
    line-height: 0.40rem;
  }
  .sta-info .row-name{
    width: 1.60rem;
    color: #999999;
  }
  .sta-info .row-value{
    flex: 1;
    color: #666666;
    font-size: 0.26rem;
  }
  .sta-info .row-info:first-child{
    margin-top: 0;
  }
  .container-flex{
    flex:1
  }
}
</style>
